<template>
  <!-- TODO: Add Aria tags -->
  <div>
    <p>
      <span>Please enter a new credit card payment details.</span>
      <span class="go-back-wrapper">
        <Button
          plain
          @click="$emit('back')"
        >
          Go Back
        </Button>
      </span>
    </p>
    <fieldset ref="addCardForm">
      <div class="payment-wrapper">
        <p class="payment-title">
          Payment Information
        </p>
        <div
          ref="card"
        />
      </div>
      <div class="payment-wrapper">
        <p class="payment-title">
          Billing Information
        </p>
        <div class="inline-input">
          <div class="input-set">
            <label
              for="name"
              class="input-label"
            >
              Cardholder Name
            </label>
            <input
              v-model="name"
              name="name"
              class="input-field"
              required
            >
          </div>
          <div class="input-set">
            <label
              for="address"
              class="input-label"
            >
              Billing Address
            </label>
            <input
              v-model="address"
              name="address"
              class="input-field"
              required
            >
          </div>
        </div>
        <div class="inline-input">
          <div class="input-set">
            <label
              for="city"
              class="input-label"
            >
              City
            </label>
            <input
              v-model="city"
              name="city"
              class="input-field"
              required
            >
          </div>
          <div class="input-set">
            <label
              for="state"
              class="input-label"
            >
              State/Province
            </label>
            <input
              v-model="state"
              name="state"
              class="input-field"
              required
            >
          </div>
        </div>
        <div class="input-set">
          <label
            for="country"
            class="input-label"
          >
            Country
          </label>
          <div class="select-container">
            <select
              v-model="country"
              name="country"
              class="country-select"
            >
              <option
                v-for="(countryOption, index) in countries"
                :key="index"
                :value="countryOption"
              >
                <span>{{ countryOption.name }}</span>
              </option>
            </select>
          </div>
        </div>
        <div class="button-wrapper">
          <Button
            type="submit"
            color="warning"
            :disabled="saving || !cardComplete"
            @click="generateToken"
          >
            <Loader v-if="saving" />
            Add new credit card
          </Button>
        </div>
      </div>
      <p
        v-show="error"
        class="error-text"
      >
        Error Occured: Please try again or contact support
      </p>
    </fieldset>
  </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue';
import Button from '../ui/Button.vue';
// eslint-disable-next-line
import Loader from '../../../public/loading.svg?inline';

const stripeCardUrl = `${process.env.VUE_APP_DJ_BASE_URL}api/cart/stripecards/`;
const stripeAPIKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

let stripe;
let elements;
let card;

const countries = [
  {
    name: 'United States',
    value: 'US',
  },
  {
    name: 'Canada',
    value: 'CA',
  },
  {
    name: 'Other',
    value: '',
  },
];
export default {
  name: 'NewCardDetails',
  components: {
    Button,
    Loader,
  },
  data() {
    return {
      cardComplete: false,
      saving: false,
      name: '',
      address: '',
      city: '',
      state: '',
      country: countries[0],
      error: false,
      countries,
    };
  },
  mounted() {
    // make sure we're running in the browser
    if (typeof Stripe !== 'undefined') {
      stripe = Stripe(stripeAPIKey);
      elements = stripe.elements();
      card = undefined;

      card = elements.create('card');
      card.mount(this.$refs.card);
      card.on('change', this.onCardChange);
    }
  },
  beforeDestroy() {
    // NOTE: If the card isn't manually destroyed, Stripe won't allow it to re-render
    if (typeof card !== 'undefined') {
      card.destroy(this.$refs.card);
    }
  },
  methods: {
    onCardChange(event) {
      this.cardComplete = event.complete;
    },
    async generateToken() {
      this.saving = true;
      const csrfToken = Vue.$cookies.get('csrftoken');
      stripe.createToken(card, {
        name: this.name,
        address_line1: this.address,
        address_city: this.city,
        address_state: this.state,
        address_country: this.country.value,
      }).then((result) => {
        axios({
          method: 'post',
          url: stripeCardUrl,
          withCredentials: true,
          headers: {
            'X-CSRFToken': csrfToken,
          },
          data: {
            stripeToken: result.token.id,
          },
        })
          .then((response) => {
            const newCard = response.data;
            this.$emit('add-new-card', newCard);
            this.saving = false;
          }).catch((err) => {
            this.error = err;
            this.saving = false;
          });
      }).catch((err) => {
        this.error = err;
        this.saving = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../variables.scss";

.button-wrapper {
  svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    animation: .75s rotate360 infinite linear;
    margin-right: 5px;
  }
}

.go-back-wrapper {
  margin: 0 5px;
  Button {
    font-weight: 300;
  }
}
.payment-title {
  font-size: 16px;
  font-weight: 500;
}
.payment-wrapper {
  margin-bottom: 20px;
}

.input-set {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-bottom: 8px;
}
.input-label {
  font-size: 12px;
  font-weight: 600;
}
.input-field {
  border: 1px solid #E1E1E9;
  border-radius: 3px;
  font-size: 14px;
  padding: 8px;
}
.StripeElement {
  border-radius: 3px;
  border: 1px solid #E1E1E9;
  font-size: 16px;
}
.StripeElement :invalid {
  border-color: $danger-color;
}

.inline-input {
  display: flex;
  justify-content: space-between;

  .input-set {
    width: 48%;
  }

  @media screen and (max-width: $license-modal-mobile) {
    flex-wrap: wrap;
    .input-set {
      width: 100%;
    }
  }
}
.select-container select {
  display: block !important;
  min-height: 24px;
  margin-bottom: 10px;
}
.error-text {
  color: $danger-color;
  font-weight: 600;
}

</style>
